export const LOGIN_PATH = '/login'
export const REGISTER_PATH = '/registro'
export const ACTIVATE_PATH = '/activar'
export const AFTER_ACTIVATE_PATH = '/'

export const errorMessage = (error: unknown, fallback: string) => (error instanceof Error && error.message) || fallback
